import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Callback = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // Client Credentials flow - no callback processing needed
    // Redirect to email config with message
    navigate('/email-config?message=oauth_configured');
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography variant="h6">
        OAuth configuration complete. Redirecting...
      </Typography>
    </Box>
  );
};

export default Callback;
